import styled from 'styled-components';

export const BrowseRelatedCatSection = styled.section`
  margin: 60px 0;
`;

export const Title = styled.h1`
  font-size: clamp(14px, 2vw, 20px);
  letter-spacing: 3px;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 18px 0 20px;
  text-transform: uppercase;
  text-align: center;
`;
export const Description = styled.h6`
  font-size: clamp(12px, 2vw, 16px);
  color: hsl(0deg, 0%, 0%, 78%);
  padding: 4px 10px 0 20%;
  text-align: left;
  font-weight: 400;
  @media (max-width: 720px) {
    padding: 0 10px;
    text-align: center;
  }
`;

export const RelatedList = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 30px;

  @media (max-width: 720px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 16px;
  }

  li {
    display: grid;
    grid-template-columns: 80% 20%;
    padding: 20px 0;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    color: rgb(0 0 0 / 87%);
    position: relative;

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: hsl(0deg, 0%, 0%, 20%);
      height: 1px;
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      background-color: #000;
      height: 1.5px;
      transition: width 0.4s;

      @media (max-width: 720px) {
        height: 0;
        width: 0;
      }
    }

    &:hover {
      &:after {
        width: 100%;
      }
    }

    @media (max-width: 720px) {
      cursor: default;
    }

    .arrow_forward {
      width: 16px;
      height: 16px;
      transform: rotate(270deg);
      margin: 0 16px 0 auto;
    }
  }
`;
